import React from "react";

import { cx } from "~/tools/class-variance";
import { mergeRefs } from "~/tools/merge-refs";

import { RelativeContainerContextProvider } from "./_relative-container-context";

export type RelativeContainerProps = React.PropsWithChildren<React.ComponentProps<"div">>;

export const RelativeContainer = React.forwardRef<HTMLDivElement, RelativeContainerProps>(
	({ className, ...props }, ref) => {
		const [element, setElement] = React.useState<null | HTMLDivElement>(null);

		return (
			<RelativeContainerContextProvider value={element}>
				<div ref={mergeRefs([ref, setElement])} {...props} className={cx("relative", className)} />
			</RelativeContainerContextProvider>
		);
	},
);
